import script from "./highBrandDeveloperSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./highBrandDeveloperSearch.vue?vue&type=script&setup=true&lang=js"

import "./highBrandDeveloperSearch.vue?vue&type=style&index=0&id=6203f71c&scoped=true&lang=css"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6203f71c"]])

export default __exports__